var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.errors),function(error,index){return _c('div',{key:'err'+index,staticClass:"alert alert-danger",attrs:{"aria-live":"polite","aria-atomic":"true","role":"alert"}},[_vm._v(" "+_vm._s(index)+" : "+_vm._s(error)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }